import React from 'react';

const MessageIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.66732 12.6666H5.33398C2.66732 12.6666 1.33398 11.9999 1.33398 8.66659V5.33325C1.33398 2.66659 2.66732 1.33325 5.33398 1.33325H10.6673C13.334 1.33325 14.6673 2.66659 14.6673 5.33325V8.66659C14.6673 11.3333 13.334 12.6666 10.6673 12.6666H10.334C10.1273 12.6666 9.92732 12.7666 9.80065 12.9333L8.80065 14.2666C8.36065 14.8533 7.64065 14.8533 7.20065 14.2666L6.20065 12.9333C6.09398 12.7866 5.84732 12.6666 5.66732 12.6666Z"
        stroke="#3772FF"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.6637 7.33333H10.6696" stroke="#3772FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.99764 7.33333H8.00363" stroke="#3772FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.32967 7.33333H5.33566" stroke="#3772FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default MessageIcon;
